import { create } from 'zustand';

export enum ApiPlatformValue {
  Ipe = 'ipe',
}

interface ConfigState {
  hasLoginSubjectSelector: boolean;
  platformName?: string;
  apiPlatformValue?: ApiPlatformValue;
}

const useConfigStore = create<ConfigState>()(() => ({
  hasLoginSubjectSelector: true,
}));

export default useConfigStore;
